import { Link } from 'react-router-dom';
import './ServiceCards.css';

const ServiceCards = (props) => {
  return (
    <div className="yk-event-col">
      <div className="yk-event-card">

        {/* Image */}
        <div className="yk-event-image-wrap">
          <Link to={props.Link} tabIndex="-1" aria-hidden="true">
            <img
              src={props.imgsrc}
              alt={props.title}
              className="yk-event-img"
            />
          </Link>
        </div>

        {/* Body */}
        <div className="yk-event-body">
          <div className="yk-event-accent" aria-hidden="true"></div>

          <h3 className="yk-event-title">
            {props.titleHtml
              ? <Link to={props.Link} dangerouslySetInnerHTML={{ __html: props.titleHtml }} />
              : <Link to={props.Link}>{props.title}</Link>
            }
          </h3>

          <p className="yk-event-desc">{props.Desc}
            <Link to={props.Link} className="readmore"> {props.Readbtn}</Link>
          </p>

          <div className="yk-event-footer">
            <Link
              to={props.RegistrationLink}
              className="yk-event-btn"
              target={props.target}
              rel={props.target === '_blank' ? 'noreferrer' : undefined}
            >
              {props.registerbtn}
              <span className="yk-btn-arrow" aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ServiceCards;